import React from "react";
import { CHANNEL_NAMES } from "../../../core/data/marketOverviewText";
import { CHANNEL_FILL } from "../../../core/theme/reportTheme";
import { INDUSTRY } from "../../../core/theme/auditsTheme";

// "Advertisers by channel": each advertiser once per channel it was seen on
// (Google Ads, Google Maps, Google SEO, Google Shopping), as shares of that
// total. Channels with none are left out.
//   mix: the roll-up's channelMix, [{ channel, advertisers, percent }]
export default function ChannelMixBar({ mix }) {
  const shown = (mix || []).filter(c => c.advertisers > 0);

  return (
    <div className={INDUSTRY.mix}>
      <div className={INDUSTRY.label}>Advertisers by channel</div>
      {shown.length === 0 ? (
        <p className={`${INDUSTRY.note} mt-1.5`}>No advertisers seen yet.</p>
      ) : (
        <>
          <div className={INDUSTRY.mixBar}>
            {shown.map(c => (
              <span
                key={c.channel} className={CHANNEL_FILL[c.channel]} style={{ flex: `${c.advertisers} 0 0` }}
                title={`${CHANNEL_NAMES[c.channel]}: ${c.advertisers.toLocaleString("en-GB")} advertisers, ${c.percent}%`}
              />
            ))}
          </div>
          <div className={INDUSTRY.mixLegend}>
            {shown.map(c => (
              <span key={c.channel} className={INDUSTRY.mixItem}>
                <span aria-hidden="true" className={`w-2 h-2 rounded-full shrink-0 ${CHANNEL_FILL[c.channel]}`} />
                {CHANNEL_NAMES[c.channel].replace("Google ", "")} {c.percent}%
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
